import { useState } from 'react';
import axios from '../../../api/sellerDataApi';

function useAdditionalInput(sellerId) {
    const [additionalAd, setAdditionalAd] = useState([]);
    const [additionalInput, setAdditionalInput] = useState('');
    const [showAdditionalInputForm, setShowAdditionalInputForm] = useState(false);
    const [loading, setLoading] = useState(false);

    const toggleAdditionalInputForm = () => {
        setShowAdditionalInputForm((prev) => !prev);
    };

    const handleAdditionalInputSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const response = await axios.submitAdditionalInput(sellerId, additionalInput);
            setAdditionalAd((prev) => [...prev, response.data.additional_ad]);
            setAdditionalInput('');
        } catch (error) {
            console.error('Error submitting additional input:', error);
        } finally {
            setLoading(false);
        }
    };

    return {
        additionalAd,
        additionalInput,
        setAdditionalInput,
        showAdditionalInputForm,
        toggleAdditionalInputForm,
        handleAdditionalInputSubmit,
        loading,
    };
}

export default useAdditionalInput;
